<div class="container no-task">
  <img *ngIf="!darkTheme && !isInIframe" src="../../../assets/images/notask.svg">
  <img *ngIf="darkTheme && !isInIframe" src="../../../assets/images/whitelogo.png" width="80px">
  <h3>{{ message }}</h3>
</div>
